module.exports = __webpack_public_path__ + "media/images/icons/google-podcast-a0a87de4e793f409a83f17947e788b41.svg";